export const isTitleEvenCount = (title, subtitle) => {
  const titleLength = (title && title.length) || 0;
  const subtitleLength = (subtitle && subtitle.length) || 0;
  const totalLength = titleLength + subtitleLength;
  return totalLength % 2 === 0;
};
